import { ITextFieldProps, TextField } from '@fluentui/react';
import { useState } from 'react';

export default (props: ITextFieldProps) => {
  const [value, setValue] = useState<string>();
  let value2: string | undefined;

  if (props.value === undefined) {
    value2 = value;
  } else {
    value2 = parseValue(props.value);
  }

  return (
    <TextField
      {...props}
      value={value2}
      styles={props.styles || style}
      onChange={(e, nv) => {
        const number = getNumberString(nv);
        let pv = parseValue(number);

        setValue(pv);
        props.onChange?.(e, pv);
      }}
    />
  );
};

export const parseInputNumber = (value: string | undefined) => {
  const parsedNumberString = getNumberString(value);
  if (typeof parsedNumberString !== "string") return undefined;

  const parsed = parseInt(parsedNumberString);

  return isNaN(parsed) ? 0 : parsed;
};

export const commaNumber = (value: string | number) => {
  return parseValue(value.toString());
};

const getNumberString = (value: string | undefined) => {
  if (typeof value === "undefined") return undefined;

  value = value.replace(/\D/g, "");

  while (value.startsWith("0") && value.length !== 1)
    value = value!.substring(1);

  return value;
};

const parseValue = (value: string | undefined) => {
  if (typeof value === "undefined") return undefined;

  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const style = { field: { textAlign: "right" } };
